export default "__VITE_ASSET__TGRM_7Mb__"